/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `Terminé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `Terminé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `En cours`


export { academy_courseStatus_registered } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `Vu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `Meilleures pratiques`


export { academy_globalHead_collection } from "./en-US.js"

export { academy_globalHead_course } from "./en-US.js"

export { academy_globalHead_lesson } from "./en-US.js"

export { academy_globalHead_metaDesc } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Académie`


export { academy_globalHead_search } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `À l'Académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `Non trouvé | Klaviyo Académie`


export { academy_pages_home_hero_button_href } from "./en-US.js"

export { academy_pages_home_hero_button_label } from "./en-US.js"

export { academy_pages_home_hero_headline } from "./en-US.js"

export { academy_pages_home_hero_subhead } from "./en-US.js"

export { academy_pages_home_learn_headline } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row1_content } from "./en-US.js"

export { academy_pages_home_learn_row1_title } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row2_content } from "./en-US.js"

export { academy_pages_home_learn_row2_title } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row3_content } from "./en-US.js"

export { academy_pages_home_learn_row3_title } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row4_content } from "./en-US.js"

export { academy_pages_home_learn_row4_title } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row5_content } from "./en-US.js"

export { academy_pages_home_learn_row5_title } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row6_content } from "./en-US.js"

export { academy_pages_home_learn_row6_title } from "./en-US.js"

export { academy_pages_home_learn_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_button_href } from "./en-US.js"

export { academy_pages_home_liveTraining_button_label } from "./en-US.js"

export { academy_pages_home_liveTraining_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_headline } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_subhead } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedIn_collectionPath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_coursePath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_title } from "./en-US.js"

export { academy_pages_home_testimonials_headline } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_text } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `Ignorer le message`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_error = () => `Veuillez saisir une adresse e-mail valide.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_placeholderText = () => `Votre adresse e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_primaryButton = () => `Commencer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `Passer au contenu principal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `Slide actuelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `Accéder à la slide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Tout rechercher`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Plan du site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Note`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Conditions requises`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Avertissement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Principales ressources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/fr-fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Demande d’accès au compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Article`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Consultez notre base de connaissances pour trouver les réponses aux questions les plus fréquemment posées. Parcourez nos articles, le forum de la communauté, les formations en direct et enregistrées, et plus encore, pour tout savoir sur l’utilisation de Klaviyo et découvrir nos stratégies performantes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Le Centre d’aide Klaviyo `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Section`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Le Centre d’aide Klaviyo `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Explorer d’autres contenus Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `Que peut-on vous aider à trouver aujourd’hui ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/fr-fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Accéder au Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Introuvable | Centre d'aide Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Articles les plus populaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Principales ressources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Découvrez des guides explicatifs, des cours et des supports pour développer votre activité avec Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Recherche par sujet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Recherche par sujet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Aucun résultat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Essayer une autre recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Aucun résultat pour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Communauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Développeurs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Ressources marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Tout voir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCode_languageString = () => `French`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `fr-FR`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `fr-fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Europe/Paris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates = () => `Prochaines dates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Environ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `min de lecture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Mise à jour le`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `Comment contacter l’assistance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Autoriser Klaviyo à me contacter suite à mon commentaire.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Décrivez ce que vous essayez de faire, d’apprendre ou de résoudre.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Veillez à ce que votre adresse e-mail comprenne un seul @, suivi d’un domaine valide (nom@exemple.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Comment pourrions-nous améliorer cet article ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Décrivez ce que vous avez aimé ou comment nous pourrions améliorer l’article.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Besoin de plus de détails ou d’explications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Sans rapport avec ma recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Merci de nous en avoir informés ! Expliquez-nous le problème plus en détail.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Pouvez-vous nous donner plus de détails ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Envoyer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Nous vous contacterons uniquement pour connaître votre avis sur cet article.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `nom@exemple.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Peu clair, confus ou difficile à comprendre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Ne correspond pas à l’expérience sur la plateforme`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Utilisez ce formulaire uniquement pour nous faire part de vos commentaires sur cet article.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `Cet article vous a-t-il été utile ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `Non`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Votre commentaire a été envoyé. Merci.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Nous sommes ravis qu’il ait pu vous être utile !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Oui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `Photo de profil de l’auteur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Image Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `min de lecture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `Lu`


export { molecules_countdownTimer_days } from "./en-US.js"

export { molecules_countdownTimer_hours } from "./en-US.js"

export { molecules_countdownTimer_minutes } from "./en-US.js"

export { molecules_countdownTimer_seconds } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `Sujet`


export { molecules_greenhouseDepartment_openRoles } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `sauvegarder`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `sauvegardé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `Suivant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `Précédent`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_passwordStrength_requirement_minLength = () => `Doit comporter au moins 12 caractères`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `s'ouvre dans un nouvel onglet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Rechercher par sujet ou mot-clé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `article`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `articles`


/**
 * @param {{ days: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d = (params) => `${params.days}j`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h = (params) => `${params.hours}h`


/**
 * @param {{ minutes: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m = (params) => `${params.minutes}m`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now = () => `Maintenant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day = () => `jour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days = () => `jours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour = () => `heure`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours = () => `heures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute = () => `minute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes = () => `minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn = () => `Cet événement aura lieu dans`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow = () => `Cet événement commence maintenant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Se déconnecter de L’académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Voir mes certificats sur Accredible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `Voir mes certificats`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Mes ressources de L’académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Se connecter à l’académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/fr/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Nous contacter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Se connecter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Assistance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/fr/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `Retour en haut de page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_overview = () => `Vue d’ensemble`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `TABLE DES MATIÈRES`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = () => `Black Friday et Cyber Monday 2024`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = () => `Faites en sorte que chaque jour compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = () => `Je suis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = () => `Je veux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = () => `ce Black Friday et Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `Image à l’affiche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewAll = () => `Voir tous les articles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `Voir la catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `Votre ressource marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `Le Blog Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_customSearchHeadline = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_placeholder = () => `Rechercher des articles de blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `jours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `heures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `secondes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType = () => `Type d’e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_announcement = () => `Annonce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productLaunch = () => `Lancement de produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productPromotion = () => `Promotion sur un produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productUpdate = () => `Mise à jour de produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_storewideSale = () => `Promotion sur toute la boutique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_examplePrompt = () => `Exemple de requête`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry = () => `Secteur d’activité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty = () => `Beauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt = () => `Présenter un nouveau rouge à lèvres mat, en exclusivité en ligne 10 nuances à choisir, trouvez la vôtre aujourd'hui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 = () => `Découvrez notre collection de rouges à lèvres mats`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 = () => `Découvrez plus de 10 nuances éclatantes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 = () => `Découvrez des rouges à lèvres mats flamboyants !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 = () => `💄 Achetez dès maintenant la dernière collection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 = () => `💋 Nouveaux rouges à lèvres mat pour un nouveau look !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 = () => `Découvrez la teinte qui vous convient`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 = () => `Sublimez votre sourire ! 💋`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 = () => `Découvrez notre nouveau rouge à lèvres mat en exclusivité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 = () => `Perfectionnez votre look avec nos nouvelles teintes ✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 = () => `Trouvez votre teinte idéale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 = () => `Le glow up commence ici 💄`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 = () => `Exclu en ligne : le nouveau rouge à lèvres mat  🚨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt = () => `Offre à durée limitée, -20 % sur toutes les crèmes solaires. N’attendez plus !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 = () => `Protégez votre glow ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 = () => `☀️ Économisez sur nos produits solaires ! 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 = () => `Le soleil est de retour, économisez sur la crème solaire !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 = () => `Grand soleil, grandes économies ! 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 = () => `Offre exclusive : -20 % sur les crèmes solaires ! 😎`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 = () => `Pour un teint éclatant, -20 % aujourd’hui !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 = () => `🌞 Protégez votre peau à moindre coût`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 = () => `Protégez votre peau sans vous ruiner`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 = () => `Une protection solaire à petit prix ! ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 = () => `Protégez-vous du soleil avec 20 % de réduction`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 = () => `-20 % sur les crèmes solaires !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 = () => `☀️ Protégez-vous ! -20 % sur les crèmes solaires 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg = () => `Biens de grande consommation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt = () => `Nouvelle torréfaction moyenne, certifiée équitable et biologique, avec des notes de poire cuite, de mélasse et d’amande. Parfait pour se concocter un espresso ou un café filtre !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 = () => `Découvrez notre nouveau café équitable 🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 = () => `Améliorez votre rituel café avec la saveur de poire cuite ! 🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 = () => `Découvrez les délices de la torréfaction moyenne équitable ☕🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 = () => `Ajoutez à votre rituel café un goût de poire cuite et d’amande 🍐☕`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 = () => `Un nouveau mélange de café délicieux ☕️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 = () => `Goûtez la perfection à chaque gorgée ! 😋`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 = () => `Réveillez-vous sur un arôme de poire cuite au four 🍐`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 = () => `Vous allez adorer vous réveiller 🌱`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 = () => `☕ Craquez pour notre nouveau café !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 = () => `Découvrez notre dernière torréfaction moyenne bio ☕`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 = () => `Nouveau café équitable aux notes uniques 🍐`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 = () => `Découvrez notre dernier café équitable 🌍`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt = () => `Pour une durée limitée : un produit acheté = un produit offert pour tous les parfums de glace. Dépêchez-vous, cette offre ne durera pas !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 = () => `Deux fois plus de glaces, deux fois moins cher !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 = () => `À vous les économies sucrées ! 🍭`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 = () => `Deux fois plus de goût ! 🍦`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 = () => `Deux fois plus de parfums, deux fois moins cher !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 = () => `Faites-vous doublement plaisir !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 = () => `Détendez-vous avec notre offre un produit acheté = un produit offert ! ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 = () => `Alerte aux bonnes affaires ! Un produit acheté, un produit gratuit 🍨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 = () => `Durée limitée : un produit acheté = un produit offert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 = () => `Dernière chance pour passer commande 🍦`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 = () => `Un produit acheté, un produit GRATUIT sur TOUS les parfums !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 = () => `Un produit acheté = un produit offert sur toutes les glaces !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 = () => `Ne passez pas à côté ! Un produit acheté, un produit offert !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion = () => `Mode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt = () => `Présenter notre nouvelle mini-robe oversize, un style unique que vous pouvez associer à des baskets pour un look cool et décontracté.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 = () => `Pour un style impeccable !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 = () => `Perfectionnez votre garde-robe 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 = () => `Nouveutés : Une magnifique mini-robe oversize !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 = () => `Pour un style casual, adoptez cette mini-robe oversize`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 = () => `La mini-robe oversize deviendra votre alliée du quotidien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 = () => `Une robe qui impressionne 💃🏻`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 = () => `Un look frais avec une touche oversize`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 = () => `Essayez notre mini-robe oversize !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 = () => `La mini-robe incontournable dont tout le monde parle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 = () => `La mini-robe oversize à ne pas rater 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 = () => `Perfectionnez votre garde-robe avec notre dernière pièce ! 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 = () => `Un style toujours impeccable !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt = () => `Pull à col rond, doux et élégant pour toutes les occasions ! En solde dès maintenant.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 = () => `Soldes sur ce pull cozy à col rond 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 = () => `Perfectionnez votre style avec ce pull élégant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 = () => `Offre imbattable sur notre pull à col rond`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 = () => `Une élégance polyvalente à moindre coût 💫`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 = () => `Perfectionnez votre style avec ce pull`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 = () => `Optez pour la douceur ! 🧶`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 = () => `Pull polyvalent en coton en solde✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 = () => `Ne laissez personne indifférent avec notre pull polyvalent ✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 = () => `Le chic confortable à des prix imbattables 🛍️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 = () => `🌟 Offre à durée limitée sur la maille`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 = () => `Ce petit pull élégant à col rond est en solde !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 = () => `Profitez dès maintenant des soldes sur notre pull à col rond !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden = () => `Maison et jardin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt = () => `Voici la toute nouvelle boite à outils 2.0. Cette version améliorée par rapport à la version précédente rassemble 40 outils pour vous accompagner au quotidien.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 = () => `Passez à la vitesse supérieure en matière de bricolage 🔧🔨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 = () => `Passez à la vitesse supérieure avec la boite à outils 2.0 🛠️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 = () => `Découvrez la boite à outils 2.0 💡`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 = () => `Allez plus loin avec la boite à outils 2.0 !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 = () => `Accomplissez vos travaux plus rapidement avec la boite à outils 2.0 🔧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 = () => `Lancez-vous dans le bricolage avec la boite à outils 2.0 !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 = () => `Profitez vite de la boite à outils 2.0 ! 🛠️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 = () => `La toute nouvelle version de votre boite à outils est arrivée !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 = () => `Passez à la vitesse supérieure en matière d’outils de bricolage 🛠️✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 = () => `Faites les choses bien avec la toute dernière version de la boite à outils ! 🛠️✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 = () => `Devenez pro du DIY !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 = () => `Les travaux ne vont pas vous rendre marteau avec nos nouveaux outils ⚙️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt = () => `Pour une durée limitée, -20 % sur tout le site, y compris sur nos poêles et casseroles en acier inoxydable les plus vendues. Faites entrer dans votre cuisine des ustensiles de cuisine de qualité professionnelle dès aujourd’hui !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 = () => `Équipez-vous comme un professionnel avec -20 % ! 🍳`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 = () => `La perfection culinaire à la maison 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 = () => `Économisez toujours + sur les ustensiles de cuisine professionnels 🍳`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 = () => `Libérez le chef qui sommeille en vous avec -20 % !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 = () => `Cuisinez comme les grands chefs avec -20 % ! 🥘`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 = () => `-20 % sur des ustensiles de cuisine de qualité professionnelle !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 = () => `Libérez le chef qui sommeille en vous avec 20 % de réduction ! 🔥`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 = () => `Perfectionnez votre cuisine à moindre coût !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 = () => `Cuisinez comme un(e) pro à prix réduit ! 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 = () => `Améliorez vos talents culinaires grâce à cette offre !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 = () => `Offre exclusive : -20 % sur tous les ustensiles de cuisine !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 = () => `Vous allez adorer cuisiner !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness = () => `Restaurants et bien-être`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt = () => `Restaurant gastronomique italien proposant un nouveau menu automnal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 = () => `Découvrez notre menu automnal !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 = () => `Découvrez de nouvelles saveurs cet automne !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 = () => `Découvrez notre délicieux menu automnal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 = () => `Goûtez aux saveurs de l’automne 🍁`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 = () => `Savourez les nuances automnales de nos nouveaux plats`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 = () => `🍁 Laissez-vous tenter par les délices italiens !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 = () => `Découvrez notre délicieux nouveau menu automnal !🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 = () => `Découvrez notre menu inspiré par l’automne 🍂`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 = () => `Savourez nos plats de saison 🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 = () => `🍁 Dégustez les meilleurs produits de saison dans notre restaurant !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 = () => `Une plongée automnale pour vos papilles ! 🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 = () => `Découvrez notre délicieux menu automnal !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt = () => `Offre à durée limitée : accès à votre salle de sport locale sans frais d’inscription. Inscrivez-vous.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 = () => `Restez en forme sans vous ruiner !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 = () => `Ne passez pas à côté de cette offre ! Zéro frais d’inscription 🎉`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 = () => `Offre exclusive : 0 frais d’inscription !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 = () => `Profitez de l’inscription gratuite !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 = () => `Adhérez maintenant et économisez 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 = () => `Optez pour une vie plus saine.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 = () => `Économisez sur les frais d’inscription, rejoignez-nous dès maintenant ! 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 = () => `La gratuité de l’inscription se termine bientôt !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 = () => `Retrouvez la forme pour moins cher 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 = () => `À ne pas manquer : 0 frais d’inscription ! 🏋️‍♂️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 = () => `Il est temps de retrouver la forme ! Aucuns frais d’inscription pour vous 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 = () => `Pas une minute à perdre ! Aucuns frais d’inscription !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_loading = () => `Génération d’objets d’e-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_submit = () => `Générer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Intégrez votre boutique en ligne et commencez à envoyer des messages avec Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Démarrer avec Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Donnez-vous toutes les chances de réussir vos envois de SMS.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/fr-fr/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Comment configurer l’envoi de SMS dans Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Créez et envoyez votre première campagne par e-mail.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/fr-fr/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `Comment créer et envoyer une campagne par e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Utilisez des formulaires pour interagir avec vos abonnés et recueillir plus de renseignements à leur sujet.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/fr-fr/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Démarrer avec les formulaires d’inscription`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Créez des flux complets à grande échelle en utilisant des saisies en langage naturel.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/fr-fr/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `Comment utiliser Flows AI pour créer un flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Recueillez les commentaires des clients et générez plus de conversions.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/fr-fr/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Démarrer avec les avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Voir plus`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. Tous droits réservés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Vos paramètres de confidentialité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Demande d’accès au compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/fr-fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Demande d’accès au compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Veillez à ce que votre adresse e-mail comprenne un seul @, suivi d’un domaine valide (nom@exemple.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Veuillez saisir une adresse e-mail valide.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `Obligatoire - Répondre par « s/o » si non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Veuillez vous assurer que le domaine du site web de votre entreprise est valide (https://exemple.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Saisir le nom de votre compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Ajouter un destinataire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Destinataires supplémentaires (facultatif)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Saisir une adresse e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `Adresse e-mail du compte Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Saisir une adresse e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Quel est l’objet de votre demande d’assistance ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Veuillez décrire le problème.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `Authentification multifacteur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Compte désactivé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Mot de passe oublié`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Demande de facture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `Assistance pour l’authentification multifacteur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Modifier le propriétaire du compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Configuration d’un nouvel appareil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `Configuration d’un nouvel appareil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problème`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Sélectionner un problème`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `Nom de la dernière campagne ou du dernier flux créé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `Saisir le nom de la campagne ou du flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `Créez une nouvelle page sur le site web de votre entreprise avec le titre « Test Klaviyo » et ajoutez l’URL ci-dessous.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `Saisir l’URL du site web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `Pour des raisons de sécurité, veuillez répondre aux questions suivantes afin de confirmer votre identité. En cas d’incertitude, veuillez indiquer « s/o ».`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `N’utilisez ce formulaire qu’en cas de problèmes liés à l’authentification multifacteur, par exemple si vous n’avez plus accès à l’appareil utilisé pour l’authentification. Ce formulaire requiert des informations personnelles pour l’authentification manuelle. Pour les problèmes qui ne sont pas liés à l’authentification multifacteur, sélectionnez une autre option.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `Date estimée de la dernière connexion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `Saisir la date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `Adresse postale de l’organisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `Saisir l’adresse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `Noms ou adresses e-mail des autres utilisateurs de votre compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `Saisir les noms ou les adresses e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `Noms ou adresses e-mail de 5 profils dans votre compte datant d’au moins 1 mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `Saisir les noms ou les adresses e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `Sélectionner un motif`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `Perte de l’accès à l’application d’authentification`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `Nouvel appareil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `Nouveau numéro de téléphone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `Code SMS non reçu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `À combien s’élevait votre dernière facture Klaviyo ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `Saisir le montant de la facture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Nom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Saisir votre nom complet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Envoyer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `URL du site web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Saisir l’URL d’un site web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Vous n’arrivez pas à accéder à votre compte ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Communiquez vos informations à notre équipe d’assistance, qui vous contactera dans les plus brefs délais.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/hc/fr-fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Votre demande a été transmise.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Notre équipe d’assistance vous répondra dans les plus brefs délais. Une réponse sera envoyée à l’adresse e-mail ou aux adresses e-mail que vous avez fournie(s).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Tous les champs sont obligatoires.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Obtenez votre présentation gratuite pour découvrir tout ce que peuvent vous apporter la plateforme de données de Klaviyo, les insights alimentés par l’IA, les SMS et e-mails personnalisés, et bien d’autres fonctionnalités. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Demander une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Envoi en cours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Parlez-nous de votre marque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Parlez-nous de votre marque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_recaptcha_privacy = () => `Ce site est protégé par reCAPTCHA, la <a href="https://policies.google.com/privacy?hl=fr">Politique de confidentialité</a> et les <a href="https://policies.google.com/terms?hl=fr">Conditions d'utilisation </a> de Google s’appliquent.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Découvrir toutes les fonctionnalités`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Voir les ressources marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Tout est prêt !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `Votre demande n’a pas abouti. Veuillez réessayer.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `Votre demande n’a pas abouti en raison d’une erreur réseau. Veuillez réessayer.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `Vous vous êtes inscrit trop souvent sur une courte période. Veuillez utiliser vos comptes existants ou contactez l’assistance client pour obtenir de l’aide. Merci.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `reCaptcha obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `Je suis une agence qui s’inscrit pour son client.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `Veuillez saisir le nom de votre entreprise.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `Nom de l’entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `Saisir le nom de votre entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `Nombre de contacts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500 000 - 1M`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1 000 - 3 000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100 000 - 500 000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `1M+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3 000 - 25 000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25 000 - 100 000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0 - 1 000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `Sélectionner le nombre de contacts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `Veuillez vous assurer que le domaine du site web de votre entreprise est valide (https://exemple.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `Site web de l’entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `Je souhaite un rendez-vous/une démo en direct.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `Veuillez en sélectionner un.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `Plateforme d’e-commerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce (Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Boutique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `J’ai quelque chose de personnalisé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `Cela ne s’applique pas à mon entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `Plateforme d’e-commerce non répertoriée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `Sélectionnez votre plateforme.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `Veillez à ce que votre adresse e-mail comprenne un seul @, suivi d’un domaine valide (nom@exemple.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `nom@exemple.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `Veuillez sélectionner votre chiffre d’affaires annuel estimé.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `Chiffre d’affaires annuel estimé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `5 M€ - 20 M€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `+ de 400 M€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `20 M€ - 400 M€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `Moins de 5 M€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `Sélectionner le chiffre d’affaires annuel estimé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Veuillez sélectionner l’utilisation que vous ferez de Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Comment utiliserez-vous Klaviyo ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `Pour l’activité de mon client`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `Pour ma propre activité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Sélectionnez l’utilisation que vous ferez de Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `Veuillez sélectionner votre type d’entreprise.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `Type d’entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `Autres biens et services non destinés à la vente au détail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `Biens au détail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `Services au détail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `Sélectionner un type d’entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_firstname_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `Nom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `Nom et prénom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_general_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_lastname_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `Inscrivez-vous aux communications marketing de Klaviyo, notamment les newsletters, les articles de blog, les actualités relatives aux produits, les webinaires et la publicité ciblée. Vous pouvez vous désabonner de notre marketing par e-mail via le lien « Se désabonner » en bas des e-mails.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `Votre mot de passe est trop simple.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `Veillez à ce que la longueur de votre mot de passe ne dépasse pas 128 caractères.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `Veillez à ce que votre mot de passe comporte au moins 8 caractères.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `Mot de passe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `Saisir votre mot de passe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `Veillez à ce que votre numéro de téléphone comprenne l’indicatif régional ou l’indicatif du pays.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `Le numéro doit comporter 15 caractères maximum.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `Numéro de téléphone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `Saisissez votre numéro de téléphone.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `Veuillez sélectionner un produit.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `Quels produits vous intéressent ? Sélectionnez-les.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `Avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `Sélectionner des produits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_website_errors_url = () => `Obligatoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `En envoyant ce formulaire, vous acceptez nos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `et`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/fr/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `Politique de confidentialité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `Conditions d’utilisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/fr/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `Créez votre compte gratuit et automatisez votre marketing avec des expériences omnicanales personnalisées qui convertissent. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `Créer un compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `Envoi en cours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `Envoyez votre première campagne en quelques minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Accès direct à`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Tous les pays`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Rechercher des emplois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Tous les systèmes sont opérationnels`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Service système défaillant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Interruption majeure du système`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Interruption mineure du service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Interruption mineure du système`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Interruption partielle du système`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Service partiellement défaillant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Système partiellement défaillant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Service en cours de maintenance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Fermer la fenêtre modale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Découvrez la Communauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Communauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `Communauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Contactez des membres de votre secteur, des partenaires et des experts Klaviyo pour trouver de l’inspiration, partager des informations et obtenir des réponses à toutes vos questions.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `S’inscrire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Formation en direct`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `Calendrier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Participez à une session en direct avec des experts Klaviyo pour découvrir les bonnes pratiques, apprendre à configurer des fonctionnalités clés et bien plus encore.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Se connecter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Assistance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `Assistance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Accédez à l’assistance par l’intermédiaire de votre compte.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Assistance par chat/virtuelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `La disponibilité varie selon la localisation et le type d’abonnement.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Assistance par e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(essai gratuit et comptes payants)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Disponible 24 h/24, 7 j/7`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `Voir toutes les catégories`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `Voir moins de catégories`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/fr/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Demander une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/fr/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Accéder à la page d’accueil de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/fr/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Accéder à la page de ressources de L’accélérateur Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Logo Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Actualités des produits Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Lu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Tout voir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCategory = () => `Catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCollection = () => `Collection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceStage = () => `Étape`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceTopic = () => `Sujet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_read_more = () => `En savoir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_search = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `Frais d’opérateur inclus, estimés à`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `Le prix par SMS/MMS est susceptible de varier en fonction de la longueur du message.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `crédit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_destination = () => `Destination`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_headline = () => `Voir combien de SMS/MMS vous pouvez envoyer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `Autriche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `Australie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `Belgique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `Canada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `Suisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `Allemagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `Danemark`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `Espagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `Finlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `France`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `Royaume-Uni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_HU = () => `Hongrie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `Irlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `Italie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `Pays-Bas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `Norvège`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `Nouvelle-Zélande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_PL = () => `Pologne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_PT = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `Suède`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `États-Unis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `nombre maximal d’envois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms_limit = () => `Les MMS peuvent contenir jusqu’à 1 600 caractères et des fichiers multimédia.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms_not_available = () => `Les MMS ne sont actuellement pas disponibles.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_not_available = () => `Non disponible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `Prix par`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePerSend = () => `prix par envoi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `Envoyer à`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_service_type = () => `Type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms_limit = () => `Les SMS sont limités à 160 caractères.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `Limite de profils actifs dépassée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactSales = () => `Contacter le service commercial`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `profils actifs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_headline = () => `Combien de profils actifs avez-vous ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subText = () => `Profils actifs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subTextInfo = () => `Il s’agit des personnes à qui vous pouvez envoyer des e-mails, comme vos abonnés et les gens qui interagissent avec vos messages.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_headline = () => `Combien souhaitez-vous de crédits SMS/MMS par mois ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subText = () => `Crédits SMS/MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subTextInfo = () => `Vous utiliserez vos crédits pour envoyer des messages par téléphone. Les SMS et les MMS ne coûtent pas le même nombre de crédits. Consultez ci-dessous le coût de chaque type de message.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `Customer Success Manager à 1 500 $/mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `Assistance par e-mail et par chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `Estimez le prix de votre abonnement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `crédits SMS/MMS gratuits par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `Assistance par e-mail pour les 60 premiers jours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `Demander une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `Combien de profils actifs avez-vous ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `Frais d’opérateur inclus pour les SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `Demander une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `Contactez-nous !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `Si vous avez plus de 250 000 profils actifs, veuillez contacter notre équipe commerciale pour trouver l’abonnement adapté à vos besoins.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `Vous pouvez utiliser vos crédits pour envoyer des SMS, des MMS ou les deux.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `En fonction de la zone géographique du destinataire, les SMS et MMS ne coûtent pas le même nombre de crédits.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `Crédits SMS/MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `e-mails envoyés par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `crédits SMS/MMS par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `Onboarding à 450 $/mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(ouvre une fenêtre modale)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_per_month = () => `Par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo = () => `Cela inclut toutes les personnes dans votre compte, quels que soient le canal (e-mails, SMS ou notifications push) ou le statut marketing.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advanced_data_platform_headline = () => `Advanced Klaviyo Data Platform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advanced_data_platform_pricingDescription = () => `prix basé sur le nombre total de profils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_collapsible_button = () => `Voir moins`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `Faites passer votre marketing au niveau supérieur. Les marques qui choisissent cette formule constatent une augmentation de 19 % de leur GMV.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `E-mail et SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_creditsSubText = () => `Crédits SMS/MMS par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_name = () => `E-mail + SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_recommended = () => `🔥 Recommandé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `Faites passer votre marketing par e-mail à la vitesse supérieure avec une solution simple qui offre une personnalisation à grande échelle.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_emails_label = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_per_month = () => `E-mails par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_expandable_button = () => `Voir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `La solution parfaite pour démarrer et essayer la plateforme client Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `Gratuit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_bottom = () => `Non disponible si vous avez plus de 250 profils actifs.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_top = () => `Commencez à envoyer des e-mails et découvrez comment l’intégration de toutes vos données vous permet de pousser la personnalisation encore plus loin.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_getStarted_text = () => `Commencer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_headline = () => `Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_price_subText = () => `* Selon le nombre de profils actifs sélectionné ci-dessus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_pricingDescription = () => `prix basé sur le nombre de profils actifs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_subText = () => `prix basé sur le nombre de profils actifs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_above250kContacts = () => `Si vous avez plus de 250 000 profils actifs, veuillez contacter notre équipe commerciale pour trouver l’abonnement adapté à vos besoins.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_below250Contacts = () => `Bénéficiez des fonctionnalités de Klaviyo AI, d’une assistance plus poussée et d’envois d’e-mails supplémentaires avec davantage de profils actifs.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_advanced_data_platform_subText = () => `Combien de profils avez-vous au total ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader = () => `Nombre total de profils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_headline = () => `Des outils marketing plus performants`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_headline = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_pricingDescription = () => `prix basé sur le nombre de commandes par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_slider_subText = () => `Combien de commandes avez-vous par mois ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_subText = () => `prix basé sur le nombre de commandes par mois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS : 4 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `Australie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS : 5 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS : 3 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `Canada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS : 7 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `France`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS : 12 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `Allemagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS : 9 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `Irlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS : 7 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `Italie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS : 10 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `Nouvelle-Zélande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS : 12 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `Pays-Bas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS : 3 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS : non applicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS : 5 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `UK`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS : 3 crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS : 1 crédit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `USA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `S’inscrire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `à partir de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `Une assistance à la mesure de votre entreprise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_button = () => `Découvrir les études de cas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_1 = () => `Cofondatrice et PDG de Fishwife`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_2 = () => `Directeur du lifecycle marketing chez Made In`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_3 = () => `Directrice principale de la rétention, AS Beauty Group`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_1 = () => `Becca Millstein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_2 = () => `Don Smolik`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_3 = () => `Katherine Cabe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_1 = () => `ROI accru`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_2 = () => `AOV en hausse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_3 = () => `CA en croissance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_1 = () => `/customers/case-studies/fishwife`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_2 = () => `/customers/case-studies/made-in-cookware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_3 = () => `/customers/case-studies/laura-geller-sms-revenue`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_1 = () => `Ce que j’aime le plus chez Klaviyo, c’est que son utilisation est à la portée de tous, experts comme débutants.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_2 = () => `Cela nous a aidés à mieux interpréter nos données et à améliorer l’expérience client.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_3 = () => `Avoir un profil client unifié, où toutes les informations client sont centralisées, c’est l’idéal.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_href = () => `/customers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_quote_end = () => `»`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_quote_start = () => `«`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_case_study = () => `Rechercher des études de cas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_compare_page = () => `Rechercher des comparaisons`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_marketing_resource = () => `Rechercher des ressources marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_newsroom_article = () => `Rechercher dans la presse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_page = () => `Rechercher des pages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_partner_page = () => `Rechercher des partenaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_podcast_page = () => `Rechercher des podcasts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_post = () => `Rechercher des articles de blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_product_update = () => `Rechercher des mises à jour de produits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_solutions_page = () => `Rechercher des solutions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_success_page = () => `Rechercher Customer Success`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_button = () => `Regarder une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_href = () => `/fr/platform-demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_subhead = () => `Pour des relations client plus personnelles et plus durables à grande échelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_benchmarks = () => `Benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_customer_hub = () => `Customer Hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_email_marketing = () => `Marketing par e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_integrations = () => `Intégrations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_mobile_push = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_profiles = () => `Profilfils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_reporting = () => `Reporting`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_reviews = () => `Avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_segments = () => `Segments`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_sms_marketing = () => `Marketing par SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_1 = () => `En savoir plus sur Klaviyo Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_2 = () => `En savoir plus sur Klaviyo Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_3 = () => `En savoir plus sur Klaviyo Service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_4 = () => `En savoir plus sur Klaviyo Data Platform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_a = () => `Marketing par e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_b = () => `Marketing par SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_c = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_d = () => `Avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_e = () => `Formulaires web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_f = () => `Flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_g = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_a = () => `/fr/products/email-marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_b = () => `/fr/products/sms-marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_c = () => `/fr/products/mobile-push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_d = () => `/fr/products/product-reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_e = () => `/fr/features/web-forms`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_f = () => `/fr/features/flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_g = () => `/fr/features/campaigns`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_a = () => `Benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_b = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_c = () => `Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_a = () => `/fr/features/benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_b = () => `/fr/products/ai`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_c = () => `/fr/products/marketing-analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_3_button_a = () => `Customer Hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_3_href_a = () => `/fr/products/customer-experience-hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_a = () => `Intégrations et API`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_b = () => `Profils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_c = () => `Segments`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_d = () => `Advanced KDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_a = () => `/fr/platform-integrations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_b = () => `/fr/features/customer-profiles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_c = () => `/fr/features/segmentation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_d = () => `/fr/products/advanced-cdp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_1 = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_2 = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_3 = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_4 = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_1 = () => `Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_2 = () => `Analyses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_3 = () => `Service client`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_4 = () => `Plateforme de données`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_1 = () => `/fr/solutions/marketing-automation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_2 = () => `/fr/solutions/analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_3 = () => `/fr/solutions/customer-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_4 = () => `/fr/solutions/customer-data-platform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_27Percent = () => `27,2 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_43Percent = () => `43,2 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_a = () => `A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_b = () => `B`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_clickRate = () => `Taux de clics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS = () => `A accepté de recevoir des SMS ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_createWithAI = () => `Créer avec l’IA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_describeFlow = () => `Décrivez le flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind = () => `Ne le laissez pas de côté ! Cliquez pour continuer vos achats.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_flowTrigger = () => `Déclencheur du flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_generateDraft = () => `Générer un brouillon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct = () => `A consulté un produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_no = () => `Non`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_smsABTest = () => `Test A/B des SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct = () => `Consulter le produit abandonné`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop = () => `Message n° 1`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS = () => `Saisir un message`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_yes = () => `Oui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue = () => `Chiffre d’affaires attribué`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber = () => `Chiffre d’affaires attribué`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_champions = () => `Champions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_championsFlow = () => `Flux Champions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_clickRate = () => `Taux de clics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_conversionOverview = () => `Vue d’ensemble des conversions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_conversionRate = () => `Taux de conversion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_eightPercent = () => `8 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_excellent = () => `Excellent`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer = () => `Offre exclusive`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent = () => `5,20 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_flowTrigger = () => `Déclencheur du flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen = () => `43 619`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo = () => `452`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_membersAdded = () => `Membres ajoutés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_membersDropped = () => `Membres perdus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_monthOne = () => `Mois 1`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_monthTwo = () => `Mois 2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_no = () => `Non`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen = () => `1 513`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_revenue = () => `Chiffre d’affaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_revenueNumber = () => `Chiffre d’affaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion = () => `Le groupe RFM est Champions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport = () => `Rapport de croissance des segments`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent = () => `7,50 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_threePercent = () => `3 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_totalMembers = () => `Nombre total de membres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_yes = () => `Oui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_accessories = () => `Accessoires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_activity = () => `Activité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_addToBag = () => `Ajouter au panier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_addToCart = () => `Ajouter au panier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_arrivingToday = () => `Livraison aujourd’hui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_chat = () => `Chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_clothing = () => `Vêtements`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_color = () => `Couleur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_coral = () => `Corail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes = () => `Chaussures de course Featherweight`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_findAStore = () => `Trouver un point de vente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_forYou = () => `Pour vous`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_help = () => `Aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet = () => `Ensemble de sport côtelé Horizon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_l = () => `L`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_maroon = () => `Marron`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus = () => `Membres : livraison gratuite pour les commandes de + de 50 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_miaWilliams = () => `Mia Valet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom = () => `mia.valet@abc.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes = () => `Ma commande vient d’arriver, et<br>j’ai l’impression qu’on m’a envoyé<br>la mauvaise taille de chaussures.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_new = () => `Nouveau`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_orders = () => `Commandes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_phoneNumber = () => `+33 1 23 45 67 89`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent = () => `Veuillez patienter un instant : nous vous mettons en contact avec un agent.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_profile = () => `Profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed = () => `Consulté récemment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_saySomething = () => `Comment pouvons-nous vous aider`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_seanH = () => `Simon H.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_selectSize = () => `Taille`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_shoes = () => `Chaussures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_sky = () => `Ciel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday = () => `Toutes nos excuses, Mia.<br>Nous allons vous envoyer l’article<br>de la bonne couleur aujourd’hui même.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine = () => `35,99 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen = () => `210 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox = () => `Unified Inbox`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_welcomeMia = () => `Bienvenue, Mia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xl = () => `XL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xs = () => `XS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xxl = () => `XXL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp = () => `Oui, c’est ma commande. Merci de votre aide !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_Enjoy = () => `Profitez de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_customerActivity = () => `Activité du client`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_discountCode = () => `Code de réduction`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_email = () => `delphine.kim@abc.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_flowTrigger = () => `Déclencheur du flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_inbox = () => `Boite de réception`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview = () => `A laissé un avis 5 étoiles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_name = () => `Delphine Kim`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_no = () => `Non`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount = () => `A ouvert l’e-mail « Remise »`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_orderDelivered = () => `Commande livrée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_orderShipped = () => `Commande expédiée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix = () => `Commande passée pour 206 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_shopNow = () => `Acheter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff = () => `-10 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy = () => `Merci pour votre commentaire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_yes = () => `Oui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_1 = () => `Envoyez des messages engageants, sur tous les canaux appropriés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_2 = () => `Identifiez ce qui fonctionne et ce que vous devez améliorer, sans informations inutiles.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_3 = () => `Personnalisez le service client pour mieux satisfaire la clientèle et accroitre les opportunités de vente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_4 = () => `Centralisez toutes les données pour avoir une vue d’ensemble du parcours de chaque client et devancer ses attentes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `Tout voir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `Regarder la vidéo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Tout effacer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Tout réduire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Toutes les mises à jour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Compte et facturation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_advanced_kdp = () => `Plateforme de données avancée Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Analyses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Audience`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Avantages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Bientôt disponible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Délivrabilité et conformité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Disponibilité générale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Sortie de produit progressive`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Intégrations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Disponibilité limitée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_marketing_analytics = () => `Klaviyo Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Type de sortie de produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Formulaires d’inscription`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Sujet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Regarder le récapitulatif trimestriel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `Accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `Rechercher des emplois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `Appliquer des filtres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `Effacer les filtres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `Pays`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `Mots-clés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `Rechercher des emplois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `Filtrer les emplois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `Où`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `Aucun emploi ne correspond à vos critères.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `Veuillez essayer des critères de recherche différents ou cliquez sur <a href="#" onclick="window.location.href='/careers/search-jobs'">Consulter toutes les offres d’emploi</a>.`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `Affichage de <strong>${params.start}</strong> à <strong>${params.end}</strong> emplois correspondants sur <strong>${params.total}</strong>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `Équipe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `Rechercher des emplois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `Rechercher des emplois | Carrières Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `Consulté récemment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `Emplois enregistrés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Vous ne trouvez pas ce que vous cherchez ? Rendez-vous sur la <a href="/email-marketing">page e-mail</a>, la <a href="/sms-marketing">page SMS</a> ou la <a href="/">page d’accueil</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Page introuvable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Cela se prononce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `heures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `heure`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Question résolue`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Académie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Toutes les ressources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Tout effacer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Tout réduire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Communauté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Développeurs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Centre d’aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Ressources marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Ressource`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Rechercher toutes les ressources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Vérifiez l’orthographe ou essayez une autre recherche.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Nous n’avons pas trouvé de résultats pour « ${params.query} ».`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Rechercher par sujet ou mot-clé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_duration = () => `Durée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_language = () => `Langue`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_location = () => `Localisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_type = () => `Type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_english = () => `Anglais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_french = () => `Français`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_spanish = () => `Espagnol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_apac = () => `Asie/Australie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_emea = () => `Europe/Afrique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_nam = () => `Amérique du Nord`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_type_liveTraining = () => `Formation en direct`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `Catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `Type d’article`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `Black Friday et Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `Étude de cas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `Comparaisons`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `Démos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `Secteurs d’activité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `Ressource marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `Presse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `Pages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `Partenaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `Podcast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `Mise à jour de produit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `Produits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `Nouveautés trimestrielles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `Solutions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `Customer Success`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `Outils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Compte et facturation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Analyses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Audience`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Délivrabilité et conformité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Intégrations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Notifications push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Avis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Formulaires d’inscription`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Principaux résultats de recherche`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Affichage de ${params.y} sur ${params.x}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Recherches suggérées`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Démarrer avec Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Démarrer avec les SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Démarrer avec la CDP de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Démarrer avec les formulaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday et Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Créer un calendrier de contenus dans Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Afficher`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Voir tous les résultats (${params.index})`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Voir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `Catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Klaviyo plan du site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_brandText = () => `Parlez-nous de votre marque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_channelsUsed = () => `Quels canaux utilisez-vous ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_fieldsRequired = () => `* Tous les champs sont obligatoires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputActiveProfiles = () => `Nombre de profils actifs*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputAverageOrderValue = () => `Valeur moyenne de la commande*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputCampaignsPerMonth = () => `Nombre de commandes envoyées par mois (e-mail et SMS)*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterActiveProfiles = () => `Saisir le nombre de profils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterAverageOrderValue = () => `Saisir le montant en dollars`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterCampaignsPerMonth = () => `Saisir le nombre de campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterFlowsPerMonth = () => `Saisir le nombre de destinataires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterMonthlyWebVisitors = () => `Saisir le nombre de visiteurs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterOrdersPerMonth = () => `Saisir le nombre de commandes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterSmsPerMonth = () => `Saisir le nombre de messages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputFlowsPerMonth = () => `Destinataires qui reçoivent un flux automatisé chaque mois*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputMonthlyWebVisitors = () => `Nouveaux visiteurs du site web/mois*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputOrdersPerMonth = () => `Nombre moyen de commandes par client et par mois*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputPrefix = () => `$`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputSmsPerMonth = () => `SMS par mois*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_roiButton = () => `Estimez votre ROI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmail = () => `E-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmailAndSms = () => `E-mail et SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_automatedFlows = () => `Flux automatisés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_campaigns = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_freeTier = () => `Votre dossier est unique et nous ne pouvons pas calculer un retour sur investissement pour vous. Comme votre entreprise a moins de 250 profils, vous pouvez utiliser Klaviyo gratuitement.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_getStartedButton = () => `Commencer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_headlineText = () => `* Estimation de votre ROI avec Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_invalidRoi = () => `Votre dossier est unique. Nous serions ravis de discuter plus en détail de la manière dont Klaviyo peut améliorer les résultats de votre entreprise.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_newSubscribers = () => `Nouveaux abonnés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_revenuePerYear = () => `par an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_signupText = () => `Inscrivez-vous pour démarrer ou discutez avec l’équipe commerciale de vos résultats en matière de retour sur investissement.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_subHeadlineText = () => `Découvrez d’où provient votre chiffre d’affaires :`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_talkToSales = () => `Contacter l’équipe commerciale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `ouvrir dans un nouvel onglet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `Articles de cet auteur`


/**
 * @param {{ category_name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = (params) => `articles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `À la une`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `Client`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `Secteur d’activité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `Plateforme`


export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { roiCalculator_results_getStartedButton_href } from "./en-US.js"

export { roiCalculator_results_talkToSales_href } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Apply } from "./en-US.js"

export { AppMarketplace_Browse_Filters_BuiltBy } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Category } from "./en-US.js"

export { AppMarketplace_Browse_Filters_CollapseAll } from "./en-US.js"

export { AppMarketplace_Browse_Filters_FilterItemWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabel } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabelWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_ResetAll } from "./en-US.js"

export { AppMarketplace_Browse_Heading } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Plural } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Singular } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body_Alt } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Heading } from "./en-US.js"

export { AppMarketplace_Details_Articles_CaseStudyImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_NavigationIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_UserGuideIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Info_ApplicationLogo_Alt } from "./en-US.js"

export { AppMarketplace_Details_InstallButton_UninstallableWarningImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Page_Title } from "./en-US.js"

export { AppMarketplace_Details_RedirectionLink_Label } from "./en-US.js"

export { AppMarketplace_Discovery_App_BuiltBy } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_ActionRequired } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_GenericPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_Installed } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_UserPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Card_BannerImage_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllApps } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllAppsAriaLabel } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL1 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2Highlight } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericMobileHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_LogInAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_SignUpAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserGreeting } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserHeading } from "./en-US.js"

export { AppMarketplace_Drawer_AccountManagement } from "./en-US.js"

export { AppMarketplace_Drawer_ApplicationManagement } from "./en-US.js"

export { AppMarketplace_Drawer_Categories } from "./en-US.js"

export { AppMarketplace_Header_CategoriesButton_Label } from "./en-US.js"

export { AppMarketplace_Header_LoginButton_Label } from "./en-US.js"

export { AppMarketplace_Header_Logo_Alt } from "./en-US.js"

export { AppMarketplace_Header_MenuIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_Placeholder } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_SearchIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_ApplicationsSection_Label } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_CategoriesSection_Label } from "./en-US.js"

export { AppMarketplace_Preview_Site_Title } from "./en-US.js"

export { AppMarketplace_Site_Description } from "./en-US.js"

export { AppMarketplace_Site_Title } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_built_by = () => `Construit par`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_carousel_close = () => `Fermer le carrousel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_carousel_image_alt = () => `Image du carrousel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_carousel_next_image = () => `Image suivante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_carousel_previous_image = () => `Image précédente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_case_study = () => `Étude de cas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_category = () => `Catégorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_cover_image = () => `Image de couverture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_developer = () => `Développeur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_features = () => `Caractéristiques`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_guide = () => `Guide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_install = () => `Installer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_install_installs = () => `Installations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_languages = () => `Langues`


/**
 * @param {{ app_name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_marketing_video = (params) => `${params.app_name} vidéo marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_overview = () => `Vue d'ensemble`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_pricing = () => `Tarification`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_pricing_free = () => `Gratuit à installer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_pricing_learn_more = () => `En savoir plus sur la tarification`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_similar_apps = () => `Applications similaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_support = () => `Support`


export { app_marketplace_details_support_email_address_label } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_support_help = () => `Ressources d'aide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_support_privacy = () => `Politique de confidentialité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_support_website = () => `Visiter le site web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_details_user_guide = () => `Guide de l'utilisateur`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_gallery_thumbnail = (params) => `+${params.count} de plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_gallery_thumbnail_alt = () => `Élément de la galerie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_install_alert_learn_more = () => `En savoir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_install_button = () => `Installer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_install_status_invalid_permissions = () => `Seuls les propriétaires de comptes, les administrateurs et les gestionnaires peuvent installer des intégrations. Contactez-les pour procéder à l'installation.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_install_status_unhealthy = () => `Votre intégration installée nécessite une action.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_install_status_uninstallable = () => `Vous devez remplir certaines conditions avant d'installer cette application.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_installed_button = () => `Installé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_manage_button = () => `Gérer`


export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_notFound_page_title } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_marketplace_preview_banner = () => `Il s'agit d'un aperçu de la liste de votre application. Actualisez la page après toute nouvelle modification pour voir les mises à jour. Les modifications publiées n'apparaîtront pas publiquement avant le 29 juillet 2025.`


export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_related_content = () => `À lire aussi`


export { molecules_passwordStrength_strength_good } from "./en-US.js"

export { molecules_passwordStrength_strength_strong } from "./en-US.js"

export { molecules_passwordStrength_strength_veryWeak } from "./en-US.js"

export { molecules_passwordStrength_strength_weak } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_profile_href } from "./en-US.js"

export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

export { organisms_moreCards_card1_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card2_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

export { organisms_whatsNew_refinements_cdp } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registed = () => `Enregistré`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_results = () => `Résultats`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeTermsLinkText = () => `conditions d’utilisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeToPartnerCodeOfConduct = () => `déclaration de confidentialité (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeToTermsOfService = () => `En envoyant ce formulaire, vous acceptez nos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_codeOfConduct_href = () => `/legal/partner-code-of-conduct`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_marketingCommunicationsConsent = () => `* En cochant la case et en saisissant votre adresse e-mail ci-dessus, vous acceptez de recevoir ponctuellement des communications marketing (telles que des newsletters, des articles de blog, des webinaires, des invitations à des événements et des informations sur les nouveaux produits), ainsi que des publicités ciblées de la part de Klaviyo. Vous pouvez vous désabonner de nos e-mails marketing à tout moment en cliquant sur le lien « Unsubscribe » en bas de nos e-mails. Pour plus d’informations sur le traitement de vos informations à caractère personnel et sur vos droits à cet égard, veuillez consulter notre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advance_data_platform_subTextInfoHeader = () => `Nombre total de profils`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_buttons_getDemo = () => `Demander une démo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_headline = () => `Discutons-en ensemble !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_richTextBody = () => `Si vous avez plus de 250 000 contacts, contactez notre équipe commerciale pour trouver l’abonnement adapté à vos besoins.`


export { organisms_pricing_calculator_locales_BR } from "./en-US.js"